import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('post');

export const state = () => ({
    ...crud.state,

    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected'
});

export const getters = {
    ...crud.getters,

    PENDING: state => state.PENDING,
    ACCEPTED: state => state.ACCEPTED,
    REJECTED: state => state.REJECTED,

    ALL_STATUSES: state => [
        {
            text: 'Pending',
            value: state.PENDING
        },
        {
            text: 'Accepted',
            value: state.ACCEPTED
        },
        {
            text: 'Rejected',
            value: state.REJECTED
        }
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        ctx,
        {
            boardId = null,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            boardId,
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/posts', { params });
    },

    accept(vuexContext, { id }) {
        return axios.$post(`/admin/posts/${id}/accept`);
    },

    reject(vuexContext, { id, reason = '' }) {
        return axios.$post(`/admin/posts/${id}/reject`, { reason });
    }
};
